export function buildLogoUrl(logoUrl, logoVersion) {
  if (!logoUrl) return null;
  if (!logoVersion) return logoUrl;

  const separator = logoUrl.includes('?') ? '&' : '?';
  return `${logoUrl}${separator}v=${encodeURIComponent(String(logoVersion))}`;
}
